import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { buildQueryString } from '@shared/util/util';
import { Observable } from 'rxjs';

const baseRef = 'relatorios';

const route = {
  consultarHistoricoAcesso: `${baseRef}/historico-acessos`,
  consultarSessaoAtiva: `${baseRef}/sessoes-ativas`,
  downloadSessaoAtiva: `${baseRef}/sessoes-ativas/excel`,
  downloadHistoricoAcesso: `${baseRef}/historico-acessos/excel`,
  consultarRelatorioEmail: `${baseRef}/relatorio-email`,

}
@Injectable({
  providedIn: 'root'
})
export class RelatoriosService {

  constructor(private apiService: ApiService) { }

  consultarHistoricoAcesso(obj: any, page: MatPageable): Observable<PageableResponse<any>> {
    return this.apiService.post<PageableResponse<any>>(`${route.consultarHistoricoAcesso}${page.query}`, obj);
  }

  consultarSessaoAtiva(obj: any, page: MatPageable): Observable<PageableResponse<any>> {
    return this.apiService.post<PageableResponse<any>>(`${route.consultarSessaoAtiva}${page.query}`, obj);
  }

  consultarSessaoAtivaSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultarSessaoAtiva}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  consultarHistoricoAcessoSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultarHistoricoAcesso}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  downloadSessaoAtiva(obj: any) {
    return this.apiService.downloadPost(`${route.downloadSessaoAtiva}`, obj);
  }

  downloadHistoricoAcesso(obj: any) {
    return this.apiService.downloadPost(`${route.downloadHistoricoAcesso}`, obj);
  }

  consultarRelatorioEmail(obj: any, page: MatPageable): Observable<PageableResponse<any>> {
    return this.apiService.post<PageableResponse<any>>(`${route.consultarRelatorioEmail}${page.query}`, obj);
  }

  consultarRelatorioEmailSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.consultarRelatorioEmail}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }





}

